import { combineReducers } from 'redux';
import authors from './author-reducer';

export default combineReducers({
  authors,
});
